import React, { useCallback, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { BitmapText, Container, useApp } from '@pixi/react';

import { gameService } from '../../../../services/gameService';
import { gameResourcesService } from '../../../../services/gameResourcesService';

import { Spine } from '../../../../core/classes/spine';

import { gameStore } from '../../../../store/gameStore';

const FreeSpinCongratsPopup = observer(({ containerConfig }) => {
  const {  isGameFreeSpinStart, isSpinStart, spinResult:{winingFreeSpinCount} } = gameStore;
  const { stage } = useApp();
  const bitmapRef = useRef(null);
  const freeSpinCongratsPopupRef = useRef(null);

  useEffect(() => {
    if (freeSpinCongratsPopupRef.current) {
      const freeSpinCongratsPopup = new Spine({ key: 'freeSpinCongratsPopup' });
      gameResourcesService.setGameFreeSpinCongratsPopupSpine(freeSpinCongratsPopup);
      freeSpinCongratsPopup.addChildToSlot('numbers', bitmapRef.current);
      freeSpinCongratsPopupRef.current.addChild(freeSpinCongratsPopup);
    }
  }, [freeSpinCongratsPopupRef]);

  const hideGameFreeSpinCongratsPopup = useCallback(() => {
    if (isGameFreeSpinStart && !isSpinStart) {
      gameResourcesService.hideGameFreeSpinCongratsPopupSpine();
      gameService.doSpin();
    }
  }, [isGameFreeSpinStart, isSpinStart]);

  useEffect(() => {
    stage.addEventListener('pointerup', hideGameFreeSpinCongratsPopup, true);
    return () => {
      stage.removeEventListener('pointerup', hideGameFreeSpinCongratsPopup, true);
    };
  }, [hideGameFreeSpinCongratsPopup, stage]);

  return (
    <>
      <Container {...containerConfig} name='FreeSpinCongratsPopup' ref={freeSpinCongratsPopupRef} />
      <BitmapText
        anchor={0.5}
        align='center'
        ref={bitmapRef}
        text={winingFreeSpinCount}
        style={{ fontName: 'freeSpinCongrats' }}
      />
    </>
  );
});

export default FreeSpinCongratsPopup;
